// Folio Occupancy Model

function layout(props) {
  const selectable = props?.selectable;
  const table_action = props ? props.table_action : ["edit", "delete"];

  const ctxView = {
    model: "hotel.folio.occupancy",
    form_action: ["edit"],
    table_action: table_action,
    domain: [],
    orderBy: [["occupancy_date", "ASC"]],
    limit: 100,
    autoSave: true,
    selectable: selectable,
    target: "folio",
    fields: {
      occupancy_date: {
        type: "date",
        readOnly: true,
        required: true,
      },
      unit_price: {
        type: "numeric",
        required: true,
        decimalPlaces: 2,
      },
      unit_price_w_tax: {
        type: "numeric",
        readOnly: true,
        decimalPlaces: 2,
      },
      state: { type: "char", readOnly: true, translate: true },
      folio: {
        type: "many2one",
        model: "hotel.folio",
        readOnly: true,
      },
      charge: {
        type: "many2one",
        model: "hotel.folio.charge",
        readOnly: true,
      },
    },
    list: [
      { name: "occupancy_date", width: "20%" },
      { name: "unit_price", width: "20%" },
      { name: "unit_price_w_tax", width: "20%" },
      { name: "charge", width: "20%" },
      { name: "state", width: "20%" },
    ],
    form: [
      { name: "occupancy_date" },
      { name: "folio" },
      {
        name: "prices",
        type: "grid",
        elements: [{ name: "unit_price" }, { name: "unit_price_w_tax" }],
        colSpan: "col-span-2",
      },
      { name: "state" },
    ],
  };

  return ctxView;
}

export { layout };
